import React from "react";

const CustomHeader = ({ title, className, onClick }) => {
  return (
      <p onClick={onClick} className={className}>
        {title}
      </p>
  );
};

export default CustomHeader;
